import { render, staticRenderFns } from "./StakingIcon.vue?vue&type=template&id=dcdfb896&scoped=true&"
import script from "./StakingIcon.vue?vue&type=script&lang=js&"
export * from "./StakingIcon.vue?vue&type=script&lang=js&"
import style0 from "./StakingIcon.vue?vue&type=style&index=0&id=dcdfb896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdfb896",
  null
  
)

export default component.exports